var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-image"},[_c('img',{attrs:{"src":_vm.src},on:{"click":_vm.clickImg}}),(_vm.preview && _vm.visible)?_c('image-viewer',{attrs:{"url-list":_vm.urlList,"on-close":_vm.handlePreviewClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }